import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

export default function Emptydata(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if the screen is small
  return (
    <Stack sx={{ mt: 0,  justifyContent: "center", alignItems: "center" }}  className="empty-data">
      {props?.icon}
      <Stack spacing={1} sx={{ pt: 1 }}>
      <Typography sx={{ color: "text.secondary" }} className="empty-text ">
        {props?.firstText}
      </Typography>
      <Typography sx={{ color: "text.secondary" }} className="empty-text ">
        {props?.secondText}
      </Typography>
      {props?.buttonText && (
        <Button
          sx={{
            width: isMobile ? "100%" : "auto", // Full-width button on mobile
          }}
          variant="contained"
          className="action-button"
          onClick={props.onButtonClick}
        >
          {props?.buttonText}
        </Button>
        )}
        </Stack>
    </Stack>
  );
}
